import { jsx as _jsx } from "react/jsx-runtime";
import { OptimizeImage } from '@telus-uds/components-web';
import { RICH_TEXT_TYPES } from '../../types';
var BLOCKS = RICH_TEXT_TYPES.BLOCKS;
export var buildEmbeddedAsset = function () {
    var _a;
    return _a = {},
        _a[BLOCKS.EMBEDDED_ASSET] = function (node) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var target = (_a = node === null || node === void 0 ? void 0 : node.data) === null || _a === void 0 ? void 0 : _a.target;
            var fields = target === null || target === void 0 ? void 0 : target.fields;
            var contentType = (_c = (_b = fields === null || fields === void 0 ? void 0 : fields.file) === null || _b === void 0 ? void 0 : _b.contentType) !== null && _c !== void 0 ? _c : (_d = target === null || target === void 0 ? void 0 : target.file) === null || _d === void 0 ? void 0 : _d.contentType;
            var fileURL = (_f = (_e = fields === null || fields === void 0 ? void 0 : fields.file) === null || _e === void 0 ? void 0 : _e.url) !== null && _f !== void 0 ? _f : (_g = target === null || target === void 0 ? void 0 : target.file) === null || _g === void 0 ? void 0 : _g.url;
            var altText = (_h = fields === null || fields === void 0 ? void 0 : fields.description) !== null && _h !== void 0 ? _h : target === null || target === void 0 ? void 0 : target.description;
            switch (contentType) {
                case 'image/png':
                case 'image/jpeg':
                case 'image/gif': {
                    return _jsx(OptimizeImage, { contentfulAssetUrl: fileURL, alt: altText });
                }
                default: {
                    return null;
                }
            }
        },
        _a;
};
